var path = require('path');
var common = require('./common');

//@
//@ ### pwd()
//@ Returns the current directory.
function _pwd(options) {
  var pwd = path.resolve(process.cwd());
  return common.ShellString(pwd);
}
module.exports = _pwd;



//////////////////
// WEBPACK FOOTER
// ./~/shelljs/src/pwd.js
// module id = 939
// module chunks = 0